import React from "react";
import PropTypes from "prop-types";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconAdquirir from "../Icons/IconAdquirir";
import IconAcelerar from "../Icons/IconAcelerar";
import IconProveer from "../Icons/IconProveer";
import IconAmpliar from "../Icons/IconAmpliar";
import IconOfrecer from "../Icons/IconOfrecer";
import IconDotar from "../Icons/IconDotar";
import IconProporcionar from "../Icons/IconProporcionar";
import IconCasosE from "../Icons/IconCasosE";
import IconFinanzas from "../Icons/IconFinanzas";
import IconRiesgos from "../Icons/IconRiesgos";

const Goals = ({ goals, subTitle, bgColor }) => {
    const renderIcon = (key) => {
        switch (key) {
            case "ADQUIRIR":
            case "HERRAMIENTAS":
                return <IconAdquirir width={65} height={82} />;
            case "ACELERAR":
                return <IconAcelerar width={65} height={65} />;
            case "PROVEER":
            case "VISION":
                return <IconProveer width={65} height={65} />;
            case "AMPLIAR":
                return <IconAmpliar width={65} height={65} />;
            case "OFRECER":
                return <IconOfrecer width={65} height={71} />;
            case "DOTAR":
                return <IconDotar width={65} height={67} />;
            case "PROPORCIONAR":
            case "CAPACITAR":
                return <IconProporcionar width={65} height={70} />;
            case "CASOS":
                return <IconCasosE width={65} height={59} />;
            case "FINANZAS":
                return <IconFinanzas width={65} height={73} />;
            case "RIESGOS":
                return <IconRiesgos width={65} height={66} />;
            default:
                return null;
        }
    };

    return (
        <Container fluid tag="section" className={`goals py-5 ${bgColor}`}>
            <Container>
                <Row className="pb-5">
                    <Col className="text-center">
                        <h2 className="title">Objetivos</h2>
                    </Col>
                </Row>
                <Row className="justify-content-center align-items-baseline">
                    {goals.map((goal, index) => (
                        <Col tag="article" lg="6" key={index} className="goals__item d-flex align-items-center">
                            {renderIcon(goal.key)}
                            <div className="ps-4">
                                <h3>{goal?.title}</h3>
                                <p>{goal.content}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
                {subTitle &&
                    <Row className="pt-5 subtitle">
                        <Col className="text-center">
                            <p>Una vez terminado el Máster, el alumno contará con los conocimientos necesarios para <br/><strong><em>administrar los recursos humanos, administrativos y ﬁnancieros de una institución.</em></strong></p>
                        </Col>
                    </Row>
                }
            </Container>
        </Container>
    );
};

Goals.propTypes = {
    goals: PropTypes.arrayOf(PropTypes.object).isRequired,
    subTitle: PropTypes.bool,
    bgColor: PropTypes.string.isRequired,
};

export default Goals;